<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" lg="12" v-if="checkAccessPrivilege('Dashboard.ScratchCardStats')">
        <div class="card">
          <div class="card-header">
            <h3 class="float-left">Scratch Card</h3>
            <div class="float-right">
              <b-link to="report/mini-games/scratchcard">View Detail Report</b-link>
            </div>
          </div>
          <div class="card-body">
            <b-tabs>
              <b-tab :title="val" v-for="(val, key) in scratchCardReportPeriod" :key="key" :active="val === scratchCardReportTime" @click="scratchCardReportTime = val">
                <b-card-text>
                  <b-row>
                    <b-col cols="6" lg="3">
                      <b-card :no-body="true">
                        <b-card-body class="p-3 clearfix">
                          <i class="fa fa-users bg-primary p-3 font-2xl mr-3 float-left"></i>
                          <div class="h5 text-primary mb-0 mt-2">{{scratchcard.totalUser}}</div>
                          <div class="text-muted text-uppercase font-weight-bold font-xs">Total Users</div>
                        </b-card-body>
                      </b-card>
                    </b-col>
                    <b-col cols="6" lg="3">
                      <b-card :no-body="true">
                        <b-card-body class="p-3 clearfix">
                          <i class="fa fa-user bg-success p-3 font-2xl mr-3 float-left"></i>
                          <div class="h5 text-success mb-0 mt-2">{{scratchcard.totalUniqueUser}}</div>
                          <div class="text-muted text-uppercase font-weight-bold font-xs">Total Unique User</div>
                        </b-card-body>
                      </b-card>
                    </b-col>
                    <b-col cols="6" lg="3">
                      <b-card :no-body="true">
                        <b-card-body class="p-3 clearfix">
                          <i class="fa fa-money bg-warning p-3 font-2xl mr-3 float-left"></i>
                          <div class="h5 text-warning mb-0 mt-2">{{scratchcard.totalPurchase}}</div>
                          <div class="text-muted text-uppercase font-weight-bold font-xs">Total Purchase</div>
                        </b-card-body>
                      </b-card>
                    </b-col>
                    <b-col cols="6" lg="3">
                      <b-card :no-body="true">
                        <b-card-body class="p-3 clearfix">
                          <i class="fa fa-gift bg-danger p-3 font-2xl mr-3 float-left"></i>
                          <div class="h5 text-danger mb-0 mt-2">{{scratchcard.totalReward}}</div>
                          <div class="text-muted text-uppercase font-weight-bold font-xs">Total Rewards</div>
                        </b-card-body>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-col>
      <b-col cols="12" lg="12" v-if="checkAccessPrivilege('Dashboard.LuckywheelStats')">
        <div class="card">
          <div class="card-header">
            <h3 class="float-left">Lucky Wheel</h3>
          </div>
          <div class="card-body">
            <b-row>
              <b-col cols="6" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="fa fa-tags bg-primary p-3 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-primary mb-0 mt-2">{{luckygame.totalTickets}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Tickets</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="6" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="fa fa-tag bg-success p-3 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-success mb-0 mt-2">{{luckygame.createTickets}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Create Tickets</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="6" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="fa fa-tag bg-warning p-3 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-warning mb-0 mt-2">{{luckygame.drawTickets}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Draw Tickets</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="6" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="fa fa-tag bg-danger p-3 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-danger mb-0 mt-2">{{luckygame.redeemTickets}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Redeem Tickets</div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col cols="12" lg="12" v-if="checkAccessPrivilege('Dashboard.ReferralStats')">
        <div class="card">
          <div class="card-header">
            <h3 class="float-left">Referral Promotion</h3>
          </div>
          <div class="card-body">
            <b-row>
              <b-col cols="6" lg="6">
                <b-row>
                  <b-col cols="6" lg="6">
                    <b-card :no-body="true">
                      <b-card-body class="p-3 clearfix">
                        <i class="fa fa-users bg-primary p-3 font-2xl mr-3 float-left"></i>
                        <div class="h5 text-primary mb-0 mt-2">{{referral.referrer}}</div>
                        <div class="text-muted text-uppercase font-weight-bold font-xs">Total Referrer</div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="6" lg="6">
                    <b-card :no-body="true">
                      <b-card-body class="p-3 clearfix">
                        <i class="fa fa-users bg-success p-3 font-2xl mr-3 float-left"></i>
                        <div class="h5 text-success mb-0 mt-2">{{referral.referee}}</div>
                        <div class="text-muted text-uppercase font-weight-bold font-xs">Total Referee</div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="6" lg="6">
                    <b-card :no-body="true">
                      <b-card-body class="p-3 clearfix">
                        <i class="fa fa-tag bg-warning p-3 font-2xl mr-3 float-left"></i>
                        <div class="h5 text-warning mb-0 mt-2">{{referral.totalTickets}}</div>
                        <div class="text-muted text-uppercase font-weight-bold font-xs">Total Tickets</div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="6" lg="6">
                    <b-card :no-body="true">
                      <b-card-body class="p-3 clearfix">
                        <i class="fa fa-tag bg-danger p-3 font-2xl mr-3 float-left"></i>
                        <div class="h5 text-danger mb-0 mt-2">{{referral.redeemTickets}}</div>
                        <div class="text-muted text-uppercase font-weight-bold font-xs">Redeem Tickets</div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6" lg="6">
                <b-row>
                  <b-col cols="12" lg="12">
                    <b-card no-body>
                      <b-card-header>
                          <h3 class="float-left"><i class='fa fa-users'></i> Top 10 Referrer Players</h3>
                      </b-card-header>
                      <b-card-body>
                        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="referral.topReferrer" :fields="topReferrerFields" >
                          <template v-slot:cell(sn)="data">
                            {{data.index+1}}
                          </template>
                          <template v-slot:cell(BonusAmount)="data">
                            {{ format(data.item.BonusAmount, '0,0.00') }}
                          </template>
                        </b-table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../events.js'
import numeral from 'numeral'

export default {
  name: 'dashboard',
  data: () => {
    return {
      luckygame: {
        totalTickets: 0,
        createTickets: 0,
        drawTickets: 0,
        redeemTickets: 0
      },
      referral: {
        referrer: 0,
        referee: 0,
        totalTickets: 0,
        redeemTickets: 0,
        topReferrer: []
      },
      topReferrerFields: [
        {key: 'sn', label: 'S.No'},
        {key: 'Username', label: 'Username'},
        {key: 'Count', label: 'Total Referred'},
        {key: 'BonusAmount', label: 'Total Bonus Earned'}
      ],
      scratchCardReportPeriod: [ 'Yesterday', 'Today' ],
      scratchCardReportTime: 'Yesterday',
      scratchcard: {
        totalUser: 0,
        totalUniqueUser: 0,
        totalPurchase: 0,
        totalReward: 0
      }
    }
  },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    scratchCardReportTime: function () {
      this.getScratchCardStats()
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getTicketsStats () {
      this.$http.get(this.API_ENDPOINT + '/luckywheel/ticket/stats', {headers: { 'Content-Type': 'application/json' }}).then(response => {
        this.luckygame.totalTickets = response.data.stats.total
        this.luckygame.createTickets = response.data.stats.create
        this.luckygame.drawTickets = response.data.stats.draw
        this.luckygame.redeemTickets = response.data.stats.redeem
        this.luckygame.topReferrer = response.data.stats.topReferrer
      }).catch(err => {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      })
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    },
    async getReferralStats () {
      try {
        let response = await this.$http.get(this.API_ENDPOINT + '/promotion/referral/stats', { headers: { 'Content-Type': 'application/json' } })
        this.referral.referrer = response.data.stats.referrer
        this.referral.referee = response.data.stats.referee
        this.referral.totalTickets = response.data.stats.total
        this.referral.redeemTickets = response.data.stats.redeem
        this.referral.topReferrer = response.data.stats.topReferrer
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async getScratchCardStats () {
      try {
        let result = await this.$http.get(this.API_ENDPOINT + '/scratchcard/ticket/getStats?time=' + this.scratchCardReportTime, { headers: { 'Content-Type': 'application/json' } })
        this.scratchcard.totalUser = result.data.TotalTicket
        this.scratchcard.totalUniqueUser = result.data.TotalUniqueUser
        this.scratchcard.totalPurchase = result.data.TotalPurchase
        this.scratchcard.totalReward = result.data.TotalReward
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    }
  },
  created () {
    // if (this.checkAccessPrivilege('Dashboard.LuckywheelStats')) {
    //   this.getTicketsStats()
    // }
    if (this.checkAccessPrivilege('Dashboard.ReferralStats')) {
      this.getReferralStats()
    }
    if (this.checkAccessPrivilege('Dashboard.ScratchCardStats')) {
      this.getScratchCardStats()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue